import './Skills.css';

const skillGroups = [
  {
    label: 'Languages',
    skills: ['Python', 'SQL', 'CUDA', 'JavaScript'],
  },
  {
    label: 'ML / Deep Learning',
    skills: ['TensorFlow', 'Keras', 'PyTorch', 'scikit-learn', 'NumPy', 'Pandas', 'Matplotlib'],
  },
  {
    label: 'Cloud & Platforms',
    skills: ['AWS', 'Azure', 'Google Cloud', 'Databricks'],
  },
  {
    label: 'Tools & Practices',
    skills: ['Git', 'Jupyter', 'Docker', 'ML Ops', 'CI/CD', 'Linux'],
  },
];

function Skills() {
  return (
    <div className="skills">
      <h2>Skills</h2>
      <div className="skills-grid">
        {skillGroups.map((group) => (
          <div key={group.label} className="skill-group">
            <h3>{group.label}</h3>
            <ul>
              {group.skills.map((s) => (
                <li key={s}>{s}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skills;
